// API base URL - automatically set based on environment
// =============================================================================
// Development: Uses .env.development (localhost:9001)
// Production:  Uses .env.production (api.transportzentrale.ch)
//
// Commands:
//   npm start        - Uses default (production URL)
//   npm run start:local - Uses localhost:9001
//   npm run build:prod  - Builds with production URL
//   npm run build:local - Builds with localhost URL
// =============================================================================
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.transportzentrale.ch';

// Country code mapping for common countries in the responses
export const COUNTRY_NAME_TO_CODE_MAP = {
  "Schweiz": "CH",
  "Deutschland": "DE",
  "Österreich": "AT",
  "Frankreich": "FR",
  "Italien": "IT",
  "Switzerland": "CH",
  "Germany": "DE",
  "Austria": "AT",
  "France": "FR",
  "Italy": "IT"
};

// ISO 3166-1 mapping between 3-letter (alpha-3) and 2-letter (alpha-2) country codes
export const COUNTRY_CODE_ISO3_TO_ISO2 = {
  "AFG": "AF", "ALB": "AL", "DZA": "DZ", "ASM": "AS", "AND": "AD", "AGO": "AO", "AIA": "AI", "ATA": "AQ", "ATG": "AG", "ARG": "AR", 
  "ARM": "AM", "ABW": "AW", "AUS": "AU", "AUT": "AT", "AZE": "AZ", "BHS": "BS", "BHR": "BH", "BGD": "BD", "BRB": "BB", "BLR": "BY", 
  "BEL": "BE", "BLZ": "BZ", "BEN": "BJ", "BMU": "BM", "BTN": "BT", "BOL": "BO", "BIH": "BA", "BWA": "BW", "BVT": "BV", "BRA": "BR", 
  "IOT": "IO", "BRN": "BN", "BGR": "BG", "BFA": "BF", "BDI": "BI", "KHM": "KH", "CMR": "CM", "CAN": "CA", "CPV": "CV", "CYM": "KY", 
  "CAF": "CF", "TCD": "TD", "CHL": "CL", "CHN": "CN", "CXR": "CX", "CCK": "CC", "COL": "CO", "COM": "KM", "COG": "CG", "COD": "CD", 
  "COK": "CK", "CRI": "CR", "CIV": "CI", "HRV": "HR", "CUB": "CU", "CYP": "CY", "CZE": "CZ", "DNK": "DK", "DJI": "DJ", "DMA": "DM", 
  "DOM": "DO", "ECU": "EC", "EGY": "EG", "SLV": "SV", "GNQ": "GQ", "ERI": "ER", "EST": "EE", "ETH": "ET", "FLK": "FK", "FRO": "FO", 
  "FJI": "FJ", "FIN": "FI", "FRA": "FR", "GUF": "GF", "PYF": "PF", "ATF": "TF", "GAB": "GA", "GMB": "GM", "GEO": "GE", "DEU": "DE", 
  "GHA": "GH", "GIB": "GI", "GRC": "GR", "GRL": "GL", "GRD": "GD", "GLP": "GP", "GUM": "GU", "GTM": "GT", "GGY": "GG", "GIN": "GN", 
  "GNB": "GW", "GUY": "GY", "HTI": "HT", "HMD": "HM", "VAT": "VA", "HND": "HN", "HKG": "HK", "HUN": "HU", "ISL": "IS", "IND": "IN", 
  "IDN": "ID", "IRN": "IR", "IRQ": "IQ", "IRL": "IE", "IMN": "IM", "ISR": "IL", "ITA": "IT", "JAM": "JM", "JPN": "JP", "JEY": "JE", 
  "JOR": "JO", "KAZ": "KZ", "KEN": "KE", "KIR": "KI", "PRK": "KP", "KOR": "KR", "KWT": "KW", "KGZ": "KG", "LAO": "LA", "LVA": "LV", 
  "LBN": "LB", "LSO": "LS", "LBR": "LR", "LBY": "LY", "LIE": "LI", "LTU": "LT", "LUX": "LU", "MAC": "MO", "MKD": "MK", "MDG": "MG", 
  "MWI": "MW", "MYS": "MY", "MDV": "MV", "MLI": "ML", "MLT": "MT", "MHL": "MH", "MTQ": "MQ", "MRT": "MR", "MUS": "MU", "MYT": "YT", 
  "MEX": "MX", "FSM": "FM", "MDA": "MD", "MCO": "MC", "MNG": "MN", "MNE": "ME", "MSR": "MS", "MAR": "MA", "MOZ": "MZ", "MMR": "MM", 
  "NAM": "NA", "NRU": "NR", "NPL": "NP", "NLD": "NL", "NCL": "NC", "NZL": "NZ", "NIC": "NI", "NER": "NE", "NGA": "NG", "NIU": "NU", 
  "NFK": "NF", "MNP": "MP", "NOR": "NO", "OMN": "OM", "PAK": "PK", "PLW": "PW", "PSE": "PS", "PAN": "PA", "PNG": "PG", "PRY": "PY", 
  "PER": "PE", "PHL": "PH", "PCN": "PN", "POL": "PL", "PRT": "PT", "PRI": "PR", "QAT": "QA", "REU": "RE", "ROU": "RO", "RUS": "RU", 
  "RWA": "RW", "BLM": "BL", "SHN": "SH", "KNA": "KN", "LCA": "LC", "MAF": "MF", "SPM": "PM", "VCT": "VC", "WSM": "WS", "SMR": "SM", 
  "STP": "ST", "SAU": "SA", "SEN": "SN", "SRB": "RS", "SYC": "SC", "SLE": "SL", "SGP": "SG", "SXM": "SX", "SVK": "SK", "SVN": "SI", 
  "SLB": "SB", "SOM": "SO", "ZAF": "ZA", "SGS": "GS", "SSD": "SS", "ESP": "ES", "LKA": "LK", "SDN": "SD", "SUR": "SR", "SJM": "SJ", 
  "SWZ": "SZ", "SWE": "SE", "CHE": "CH", "SYR": "SY", "TWN": "TW", "TJK": "TJ", "TZA": "TZ", "THA": "TH", "TLS": "TL", "TGO": "TG", 
  "TKL": "TK", "TON": "TO", "TTO": "TT", "TUN": "TN", "TUR": "TR", "TKM": "TM", "TCA": "TC", "TUV": "TV", "UGA": "UG", "UKR": "UA", 
  "ARE": "AE", "GBR": "GB", "USA": "US", "UMI": "UM", "URY": "UY", "UZB": "UZ", "VUT": "VU", "VEN": "VE", "VNM": "VN", "VGB": "VG", 
  "VIR": "VI", "WLF": "WF", "ESH": "EH", "YEM": "YE", "ZMB": "ZM", "ZWE": "ZW", "ALA": "AX", "XKX": "XK"
};

// Inverse mapping from ISO 2 to ISO 3
export const COUNTRY_CODE_ISO2_TO_ISO3 = Object.fromEntries(
  Object.entries(COUNTRY_CODE_ISO3_TO_ISO2).map(([iso3, iso2]) => [iso2, iso3])
);

// Country groupings for shipping method determination
// EU member states (27 countries)
export const EU_COUNTRIES = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 
  'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 
  'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'
];

// European but not EU (includes EFTA, UK, and other European countries)
export const NON_EU_EUROPEAN = [
  'AL', 'AD', 'AM', 'AZ', 'BY', 'BA', 'CH', 'GE', 'IS', 'LI', 
  'MD', 'MC', 'ME', 'MK', 'NO', 'RU', 'RS', 'SM', 'TR', 'UA', 'GB', 'VA', 'XK'
];

// Countries with direct land connections to Europe
export const EUROPE_ADJACENT = [
  'MA', 'DZ', 'TN', 'LY', 'EG', 'IL', 'JO', 'LB', 'SY', 'IQ', 'IR'
];

// Major maritime hubs for sea freight
export const MAJOR_PORTS = [
  'CN', 'SG', 'KR', 'JP', 'IN', 'MY', 'TH', 'VN', 'ID', 'PH', 
  'AE', 'SA', 'QA', 'OM', 'BH', 'KW', 'EG', 'ZA', 'NG', 'US', 
  'CA', 'MX', 'PA', 'BR', 'AR', 'CL', 'PE', 'CO', 'AU', 'NZ'
];

// Regions where air freight is predominant due to limited infrastructure
export const AIR_PREDOMINANT = [
  'AF', 'UZ', 'TM', 'TJ', 'KG', 'KZ', 'MN', 'NP', 'BT', 
  'BD', 'LK', 'MV', 'MM', 'LA', 'KH', 'BN', 
  'PG', 'FJ', 'SB', 'VU', 'NC', 'PF',
  'CI', 'GH', 'TG', 'BJ', 'BF', 'ML', 'NE', 'TD', 'SD', 'ER', 'ET', 
  'DJ', 'SO', 'KE', 'UG', 'TZ', 'RW', 'BI', 'CD', 'CG', 'GA', 'CM',
  'GQ', 'CF', 'SS', 'AO', 'NA', 'BW', 'ZM', 'ZW', 'MZ', 'MG', 'MU', 
  'RE', 'SC', 'YT', 'KM'
];

// Region center coordinates for distance calculation
export const REGION_CENTERS = {
  westEurope: { lat: 48.8566, lng: 2.3522 },    // Paris
  eastEurope: { lat: 50.4501, lng: 30.5234 },   // Kiev
  northAfrica: { lat: 30.0444, lng: 31.2357 },  // Cairo
  middleEast: { lat: 25.2048, lng: 55.2708 },   // Dubai
  southAsia: { lat: 28.6139, lng: 77.2090 },    // Delhi
  eastAsia: { lat: 39.9042, lng: 116.4074 },    // Beijing
  oceania: { lat: -33.8688, lng: 151.2093 },    // Sydney
  northAmerica: { lat: 40.7128, lng: -74.0060 }, // New York
  southAmerica: { lat: -23.5505, lng: -46.6333 }, // São Paulo
  centralAfrica: { lat: -1.9403, lng: 29.8739 },  // Rwanda
};

// Landlocked countries (without sea access)
export const LANDLOCKED_COUNTRIES = [
  'AF', 'AD', 'AM', 'AT', 'AZ', 'BY', 'BT', 'BO', 'BW', 'BI', 
  'CF', 'CH', 'CZ', 'HU', 'KZ', 'KG', 'LA', 'LS', 'LI', 'LU', 
  'MK', 'MW', 'ML', 'MD', 'MN', 'NE', 'PY', 'RW', 'SM', 'RS', 
  'SS', 'SK', 'SZ', 'TJ', 'TM', 'UG', 'UZ', 'VA', 'ZM', 'ZW'
];